import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App.js';
import './styles/app.css';

// The chosen theme, before the first paint: applied in an effect it arrived a frame late (a flash of the
// OS theme) and after the header's theme button had already read the old value.
try {
  const saved = localStorage.getItem('arc.theme');
  if (saved === 'light' || saved === 'dark') document.documentElement.dataset.theme = saved;
} catch { /* storage blocked: the OS theme */ }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
